import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import ahana from "../../images/ahana.png";
import "./Topbar.css";
import { Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import { getEmployeeDetails, logout } from "../../api/ApiConfig";
import { CgProfile } from "react-icons/cg";
import { MdLockOutline } from "react-icons/md";
import { LuCircleHelp } from "react-icons/lu";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";
import Cookies from "js-cookie";
import iso_ukas from "../../images/ISO1.png";
import iso from "../../images/ISO2.jpeg";
import LogoutModal from "../../component/logout/Logout";
import ChangePasswordModal from "../authentication/changePassword/ChangePassword";
import Sidebar from "../home/sidebar/Sidebar";
import { FiUser } from "react-icons/fi";

function Topbar() {
  const [employee, setEmployee] = useState({
    emp_id: "",
    name: "",
    email: "",
    dob: "",
    phn: "",
    role_ids: [],
    u_id: null,
  });
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const validTopRoutes = ["/", "/forget-password", "/reset-password"];

  useEffect(() => {
    if (!validTopRoutes.includes(location.pathname)) {
      fetchEmployeeData();
    } else {
      setEmployee({});
    }
  }, [location.pathname]);

  const fetchEmployeeData = async () => {
    try {
      const data = await getEmployeeDetails();
      if (data?.emp_id && data?.email) {
        setEmployee(data);
      } else {
        toast.error("Invalid user data from server");
        setEmployee({});
      }
    } catch (error) {
      toast.error("Failed to fetch employee details");
      console.error("Fetch error:", error);
      setEmployee({});
    }
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = async () => {
    try {
      await logout();
      Cookies.remove("access_token");
      Cookies.remove("sid");
      Cookies.remove("userid");
      localStorage.clear();
      setEmployee({});
      setShowLogoutModal(false);
      navigate("/");
    } catch (err) {
      toast.error("Failed to Logout");
      setShowLogoutModal(false);
    }
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      {/* The drifting star/bubble background layer */}
      <div className="star-field-overlay" />

      <Navbar sticky="top" className="home-top w-100">
        <Container fluid className="d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <button
              className="sidebar-toggle-btn me-3"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              <GiHamburgerMenu size={24} color="#856cfe" />
            </button>

            <Navbar.Brand className="d-flex align-items-center">
              <img
                src={ahana}
                alt="logo of ahana"
                className="logo"
                style={{ paddingLeft: 10 }}
              />
            </Navbar.Brand>
          </div>

          {!validTopRoutes.includes(location.pathname) && employee.emp_id && (
            <div className="font d-flex justify-content-center align-items-center">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={iso_ukas}
                  alt="iso of ahana"
                  className="iso-logo"
                  style={{ paddingLeft: 10, width: 50 }}
                />
                <img
                  src={iso}
                  alt="iso of ahana"
                  className="iso-logo"
                  style={{ paddingLeft: 10, width: 50 }}
                />

                <div
                  className="d-flex flex-column align-items-start"
                  style={{ marginRight: "50px", marginLeft: "20px" }}
                >
                  <span className="username  mt-1">{employee.name}</span>
                  <span className="username mt-1">{employee.emp_id}</span>
                </div>
              </div>

              <Dropdown className="dropstart">
                <Dropdown.Toggle
                  variant="info"
                  className="p-0 border-0"
                  style={{ boxShadow: "none" }}
                  id="dropdown-custom-components"
                >
                  <FiUser 
                    size={25}
                    className="usericon"
                 
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown">
                  <Dropdown.Item onClick={() => setShowModal(true)}>
                    <MdLockOutline size={20} /> Change password
                  </Dropdown.Item>
                  <Dropdown.Item
                    as="a"
                    href="https://hr.hwtpl.com/Ahana/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LuCircleHelp size={20} /> Help Desk
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleLogoutClick} className="logout">
                    <RiLogoutBoxRLine size={20} /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </Container>
      </Navbar>

      {/* Logout Modal */}
      <LogoutModal
        show={showLogoutModal}
        onCancel={handleCancelLogout}
        onConfirm={handleConfirmLogout}
      />

      {/* Sidebar */}
      {isSidebarOpen && (
        <div className="sidebar-overlay">
          <div className="sidebar-container">
            <Sidebar />
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {showModal && <ChangePasswordModal onClose={() => setShowModal(false)} />}
    </>
  );
}

export default Topbar;